module.exports = __webpack_public_path__ + "img/4.ed60c666.png";